import { render } from "./UserAction.vue?vue&type=template&id=ab505b36"
import script from "./UserAction.vue?vue&type=script&lang=js"
export * from "./UserAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__